// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-7d10f598] .form-control:disabled {\n  background: rgb(238, 238, 238);\n}\n", ""]);
// Exports
module.exports = exports;
